import React from "react";
import { Icon, Message } from "semantic-ui-react";

const RegistroDigitalAppMessage = () => {
  return (
    <>
      <Message attached="bottom" size="small" color="blue">
        <Icon name="warning circle" />
        Puedes realizar tu actualización de datos mediante la banca móvil,
        descargalo{" "}
        <a
          href="https://play.google.com/store/apps/details?id=pe.com.prymera.digital.app"
          target="_blank"
          rel="noopener noreferrer"
        >
          aquí
        </a>
      </Message>
    </>
  );
};

export default RegistroDigitalAppMessage;
